export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/video_marketing.ddaf748.svg";